module.exports = __webpack_public_path__ + "static/Bressay-6aff53b59684ed456e7eb5c6699e784d.ttf";